import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Course_setBasicInformation($course: [CourseInformation]) {
    Course_setBasicInformation(course: $course) {
      id
    }
  }
`;

const courseSetBasicInformation = async course =>
  graphql(mutation, { course })
    .then(data => data.Course_setBasicInformation)
    .catch(e => e);

export default courseSetBasicInformation;
